// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__17nPg","footer":"ModalUpdate_footer__10phR"};